import {
  Link as ChakraLink,
  Heading,
  Image,
  Stack,
  Text,
} from '@chakra-ui/react';
import Link from 'next/link';
import { useState } from 'react';
import LoginForm from '@/components/login/LoginForm';
import LoginLayout from '@/components/login/LoginLayout';
import useSmartToast from '@/hooks/SmartToast';
import { authClient } from '@/lib/auth';

export default function LoginAdmin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const toast = useSmartToast();

  const session = authClient.useSession();

  const handleLogin = async e => {
    e.preventDefault();

    await authClient.signIn.email(
      {
        email: email.trim(),
        password: password.trim(),
        rememberMe: true,
      },
      {
        onSuccess: () => {
          toast.success('Login Successful.');
        },
        onError: error => {
          toast.error(null, error?.error?.message || 'Something went wrong.');
        },
      },
    );
  };

  return (
    <Stack h='full' mt='28' p='8' alignItems='center'>
      <Stack
        as='form'
        w='full'
        px='7'
        py='5'
        gap='4'
        maxW='md'
        rounded='lg'
        border='1px solid'
        borderColor='gray.300'
        bg='white'
        onSubmit={handleLogin}
      >
        <Stack gap='2'>
          <Image
            src='/images/brand-logo.png'
            alt='Procura Logo'
            w='fit-content'
            h='10'
            alignSelf='center'
          />
          <Heading size='md' mt='2' fontWeight='semibold' color='gray.800'>
            Hello!
          </Heading>
          <Text fontWeight='medium' color='gray.400'>
            Login to your Account to view and manage your procurement
          </Text>
        </Stack>

        <LoginForm
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          isPending={session.isPending}
        />

        <ChakraLink
          as={Link}
          href={`/forgot-password/admin`}
          ml='auto'
          fontSize='sm'
          color='procura-blue'
        >
          Forgot Password?
        </ChakraLink>
      </Stack>
    </Stack>
  );
}

LoginAdmin.getLayout = page => <LoginLayout>{page}</LoginLayout>;
